<template>
  <el-dialog
    class="xh-dialog"
    :class="{ noPadding: noPadding, isBlack: isBlack }"
    v-dialogDrag
    :visible="dialogVisible"
    @update:visible="visibleHandler"
    v-bind="$attrs"
    v-on="$listeners"
    :title="title"
  >
    <slot></slot>
    <template #title>
      <slot name="title"></slot>
    </template>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>
<script>
export default {
  directives: {
    dialogDrag: {
      bind(el, binding, vnode, oldVnode) {
        const dialogHeaderEl = el.querySelector(".el-dialog__header");
        const dragDom = el.querySelector(".el-dialog");
        dialogHeaderEl.style.cursor = "move";

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty =
          dragDom.currentStyle || window.getComputedStyle(dragDom, null);

        dialogHeaderEl.onmousedown = (e) => {
          // 鼠标按下，计算当前元素距离可视区的距离
          const disX = e.clientX - dialogHeaderEl.offsetLeft;
          const disY = e.clientY - dialogHeaderEl.offsetTop;

          // 获取到的值带px 正则匹配替换
          let styL, styT;

          // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
          if (sty.left.includes("%")) {
            styL =
              +document.body.clientWidth * (+sty.left.replace(/\%/g, "") / 100);
            styT =
              +document.body.clientHeight * (+sty.top.replace(/\%/g, "") / 100);
          } else {
            styL = +sty.left.replace(/\px/g, "");
            styT = +sty.top.replace(/\px/g, "");
          }

          document.onmousemove = function (e) {
            // 通过事件委托，计算移动的距离
            const l = e.clientX - disX;
            const t = e.clientY - disY;

            // 移动当前元素
            dragDom.style.left = `${l + styL}px`;
            dragDom.style.top = `${t + styT}px`;

            // 将此时的位置传出去
            // binding.value({x:e.pageX,y:e.pageY})
          };

          document.onmouseup = function (e) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      },
    },
  },
  props: {
    height: {
      type: String,
      default: "",
    },
    maxHeight: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    isBlack: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
    };
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      //设置了弹窗高度
      if (that.height) {
        that.$el.children[0].style.height = that.height;
      }
      //如果设置了最大高度
      if (that.maxHeight) {
        that.$el.children[0].style["max-height"] = that.maxHeight;
      }
    });
  },
  methods: {
    visibleHandler(value) {
      this.dialogVisible = value;
    },
  },
  watch: {
    dialogVisible(newValue) {
      this.$emit("update:visible", newValue);
    },
    visible(newValue) {
      if (newValue === true) {
        this.$el.children[0].style.left = "unset";
        this.$el.children[0].style.top = "unset";
      }
      this.dialogVisible = newValue;
    },
  },
};
</script>
<style lang="less" scoped>
.xh-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.noPadding {
  /deep/.el-dialog {
    .el-dialog__body {
      padding: 0px;
    }
  }
}
/deep/.el-dialog {
  margin: 0 auto !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .el-dialog__header {
    background: #f5f7fa;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    height: 40px;
    border-bottom: 1px solid #f0f0f0;
    border-radius: 2px 2px 0 0;
    box-sizing: border-box;
    color: #1e1e1e;
    font-size: 16px;
    .el-dialog__title {
      color: #1e1e1e;
      font-size: 16px;
    }
    .el-dialog__headerbtn {
      position: absolute;
      top: 12px;
      right: 16px;
      padding: 0;
      background: 0 0;
      border: none;
      outline: 0;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .el-dialog__body {
    height: calc(100% - 175px);
    overflow: hidden;
    overflow-y: auto;
    padding: 16px;
    flex: 1;
  }

  .el-dialog__footer {
    padding: 16px 16px 16px 16px;
  }
}

.isBlack {
  /deep/.el-dialog {
    .el-dialog__header {
      height: 60px;
      background: linear-gradient(180deg, #294c99 0%, #122560 100%);
      border-bottom: 1px solid #122560;
      .el-dialog__title {
        color: #fff;
      }
      .el-dialog__headerbtn {
        .el-icon-close {
          color: #fff;
        }
      }
    }
    .el-dialog__body {
      background: #132250;
      padding: 0;
    }
  }
}
</style>
